import ResourceManager from './ResourceManager'

export function PortfolioAdmin() {
  return (
    <ResourceManager
      title="Portfolio"
      endpoint="/portfolio"
      folder="portfolio"
      imageField="Project image"
      fields={[
        { name: 'title', label: 'Project title' },
        { name: 'companyName', label: 'Company name' },
        { name: 'category', label: 'Category' },
        { name: 'technologies', label: 'Technologies' },
        { name: 'projectUrl', label: 'Project URL' },
        { name: 'sortOrder', label: 'Display order', default: '0' },
        { name: 'isPublished', label: 'Status', type: 'select', options: [{ value: '1', label: 'Published' }, { value: '0', label: 'Hidden' }], default: '1' },
        { name: 'description', label: 'Description', type: 'textarea', full: true },
      ]}
    />
  )
}

export function PartnersAdmin() {
  return (
    <ResourceManager
      title="Partners"
      endpoint="/partners"
      folder="partners"
      imageField="Logo"
      fields={[
        { name: 'name', label: 'Partner name' },
        { name: 'websiteUrl', label: 'Website URL' },
        { name: 'sortOrder', label: 'Display order', default: '0' },
        { name: 'isPublished', label: 'Status', type: 'select', options: [{ value: '1', label: 'Published' }, { value: '0', label: 'Hidden' }], default: '1' },
      ]}
    />
  )
}

export function TestimonialsAdmin() {
  return (
    <ResourceManager
      title="Testimonials"
      endpoint="/testimonials"
      folder="testimonials"
      imageField="Profile image"
      fields={[
        { name: 'clientName', label: 'Client name' },
        { name: 'company', label: 'Company' },
        { name: 'position', label: 'Position' },
        { name: 'rating', label: 'Rating (1-5)', default: '5' },
        { name: 'sortOrder', label: 'Display order', default: '0' },
        { name: 'isPublished', label: 'Status', type: 'select', options: [{ value: '1', label: 'Published' }, { value: '0', label: 'Hidden' }], default: '1' },
        { name: 'content', label: 'Testimonial', type: 'textarea', full: true },
      ]}
    />
  )
}

export { default as FaqsAdmin } from './AssistantQAAdmin'
